import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import s from './SkeletonLoader.module.scss';

const SkeletonLoader = ({ size = 'small' }) => {
    const rootCls = classNames(s.Root, {
        [s['Root--Cover']]: size === 'cover',
    });

    return (
        <div className={rootCls}>
            <div className={s.Container}>
                {size === 'cover' && <div className={s.Cover}></div>}
                {size !== 'cover' && (
                    <>
                        <div className={s.TopBar}></div>
                        {size === 'large' && (
                            <div className={s.MiddleBar}></div>
                        )}
                        <div className={s.BottomBar}></div>
                    </>
                )}
            </div>
        </div>
    );
};

SkeletonLoader.propTypes = {
    size: PropTypes.oneOf(['small', 'large']),
};

export default SkeletonLoader;
